import qs from "qs";
import React, { FC, ReactNode, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

// 渠道参数需求原型稿：
// https://xc052f.axshare.com/#g=1&p=%E7%9B%AE%E5%89%8D%E5%85%AC%E4%BC%9A%E5%85%A5%E9%A9%BB%E9%A1%B5%E7%8E%B0%E6%9C%89%E5%85%A5%E5%8F%A3%E5%A2%9E%E5%8A%A0%E6%B8%A0%E9%81%93%E5%8F%B7
export const ChannelIdContext = React.createContext<string>("0"); // 流量渠道参数，默认 '0'

const ChannelIdContextWrap: FC<{ children: ReactNode }> = ({ children }) => {
  const location = useLocation();
  const { a } = qs.parse(location.search, { ignoreQueryPrefix: true });
  // 只在落地的时候设置一次, web 端默认 '0'
  const [channelId] = useState(a || "0");

  useEffect(() => {
    console.log("channelId", channelId);
  }, [channelId]);

  return (
    <ChannelIdContext.Provider value={channelId as string}>{children}</ChannelIdContext.Provider>
  );
};

export default ChannelIdContextWrap;
